import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Edit2, Trash2 } from "lucide-react";
import { api } from "../utils/api";
import { useAuth } from "../contexts/AuthContext";

export default function KnowledgeBaseDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const { hasRole } = useAuth();
  const [a, setA] = useState(null);
  const isAuthor = hasRole("admin", "it_team", "it_manager", "it_security");

  useEffect(() => { api.get(`/api/kb/articles/${id}`).then((r) => setA(r.data)); }, [id]);

  async function remove() {
    if (!window.confirm("Delete this article?")) return;
    await api.delete(`/api/kb/articles/${id}`);
    nav("/knowledge-base");
  }

  if (!a) return <div className="text-gray-500">Loading…</div>;

  return (
    <div className="space-y-4 max-w-4xl">
      <Link to="/knowledge-base" className="text-sm text-brand-600 hover:underline flex items-center gap-1">
        <ArrowLeft size={14} /> Back to Knowledge Base
      </Link>
      <article className="card p-6">
        <div className="text-xs text-gray-500">{a.category}</div>
        <h1 className="text-2xl font-bold mt-1">{a.title}</h1>
        <div className="text-sm text-gray-500 mt-2">
          By {a.author_name} · {new Date(a.updated_at).toLocaleDateString()} · {a.views} views
          {a.status !== "published" && <span className="ml-2 badge bg-gray-100 text-gray-700">{a.status}</span>}
        </div>
        {a.tags?.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1">
            {a.tags.map((t) => <span key={t} className="badge bg-brand-50 text-brand-700">{t}</span>)}
          </div>
        )}
        <div className="prose prose-sm max-w-none mt-6 whitespace-pre-wrap text-gray-800 leading-relaxed">
          {a.content}
        </div>
        {isAuthor && (
          <div className="mt-6 pt-4 border-t flex gap-2">
            <Link to={`/knowledge-base/${id}/edit`} className="btn-secondary flex items-center gap-1">
              <Edit2 size={14} /> Edit
            </Link>
            {hasRole("admin", "it_manager") && (
              <button onClick={remove} className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded flex items-center gap-1">
                <Trash2 size={14} /> Delete
              </button>
            )}
          </div>
        )}
      </article>
    </div>
  );
}
